import Cookies from "js-cookie";

// Set cookie
export function setCookie(
  name,
  value,
  options = { expires: 21, domain: "oscars.org" }
) {
  if (window.location.hostname === "localhost") {
    Cookies.set(name, value, { expires: 21 });
  } else {
    Cookies.set(name, value, options);
  }
}

// Get cookie
export function getCookie(name, options = {}) {
  return Cookies.get(name, options);
}

// Remove cookie
export function removeCookie(name, options = {}) {
  return Cookies.remove(name, options);
}

// Not currently implemented
export function getDomain(getState) {
  let domain;

  // Make exception for local environment.
  if (window.location.hostname === "localhost") {
    domain = "localhost";
  } else {
    const state = getState();
    const env = process.env.REACT_APP_BUILD;

    domain = state.contentful[env].domain;
  }

  return domain;
}
